import { render, staticRenderFns } from "./InvoiceChildren.vue?vue&type=template&id=4d7ddce0&scoped=true&"
import script from "./InvoiceChildren.vue?vue&type=script&lang=js&"
export * from "./InvoiceChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ddce0",
  null
  
)

export default component.exports